// templates/InvoiceSplitView.tsx

import { Grid, GridItem } from '@chakra-ui/react';
import InvoiceListPanel from '@/components/Organisms/InvoiceListPanel';
import InvoiceViewerPanel from '@/components/Organisms/InvoiceViewerPanel';
import type { Invoice } from '@/types/invoice';

interface InvoiceSplitViewProps {
    invoices: Invoice[];
    activeInvoice: Invoice;
    getStatus: (invoice: Invoice) => { label: string; color: string };
    onInvoiceClick: (invoice: Invoice) => void;
    isLoadingPDF: boolean;
    pdfUrl: string;
    isEmptyOrUnavailable?: boolean;
    isLoadError?: boolean;
}

const InvoiceSplitView = ({
    invoices,
    activeInvoice,
    getStatus,
    onInvoiceClick,
    isLoadingPDF,
    pdfUrl,
    isEmptyOrUnavailable,
    isLoadError,
}: InvoiceSplitViewProps) => (
    <Grid
        gap={4}
        height="70vh"
        maxHeight="700px"
        minHeight="500px"
        templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
        overflow="hidden"
    >
        <GridItem colSpan={{ base: 1, md: 1 }} overflow="hidden">
            <InvoiceListPanel
                invoices={invoices}
                activeInvoice={activeInvoice}
                getStatus={getStatus}
                onInvoiceClick={onInvoiceClick}
            />
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }} overflow="hidden">
            <InvoiceViewerPanel
                invoice={activeInvoice}
                isLoading={isLoadingPDF}
                url={pdfUrl}
                isEmptyOrUnavailable={isEmptyOrUnavailable}
                isLoadError={isLoadError}
            />
        </GridItem>
    </Grid>
);
export default InvoiceSplitView;